import { sidebarMenuSlice } from './slice';
export const { toggleSideBarMenu } = sidebarMenuSlice.actions;
